import { Component, StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './styles.css';

function reportAppStatus(status, error) {
  const message = error && error.message ? error.message : String(error || '');
  window.__ONECEO_APP_STATUS__ = window.__ONECEO_APP_STATUS__ || { status: 'booting', errors: [] };
  window.__ONECEO_APP_STATUS__.status = status;
  if (message) window.__ONECEO_APP_STATUS__.errors.push(message);
  const root = document.getElementById('root');
  if (root) root.setAttribute('data-oneceo-app-status', status);
  if (status === 'error') {
    console.error('[oneceo-app-runtime]', error);
  }
}

class OneCeoAppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    reportAppStatus('error', error);
  }

  render() {
    if (this.state.error) {
      return (
        <main className="oneceo-runtime-error" role="alert">
          <section>
            <p>OneCEO browser runtime error</p>
            <h1>页面渲染失败</h1>
            <pre>{this.state.error.message || String(this.state.error)}</pre>
          </section>
        </main>
      );
    }
    return this.props.children;
  }
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  reportAppStatus('error', new Error('Missing #root element'));
  throw new Error('Missing #root element');
}

createRoot(rootElement).render(
  <StrictMode>
    <OneCeoAppErrorBoundary>
      <App />
    </OneCeoAppErrorBoundary>
  </StrictMode>
);

requestAnimationFrame(() => {
  if (rootElement.childElementCount > 0 && rootElement.getAttribute('data-oneceo-app-status') !== 'error') {
    reportAppStatus('mounted');
  }
});
